function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333331;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dark_Grey_Shizzz",
  "data-name": "Dark Grey Shizzz"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 50.26,
  cy: 14.77,
  r: 14.77
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "48.98 25.64 48.98 36.94 60.7 25.22 48.98 25.64"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 45.08,
  y: 25.22,
  width: 3.9,
  height: 11.72,
  transform: "translate(94.06 62.16) rotate(180)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 14.77,
  cy: 14.77,
  r: 14.77
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "13.49 25.64 13.49 36.94 25.22 25.22 13.49 25.64"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 9.59,
  y: 25.22,
  width: 3.9,
  height: 11.72,
  transform: "translate(23.09 62.16) rotate(180)"
})));

var SvgQuoteEnd = function SvgQuoteEnd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65.03 36.94",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuoteEnd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/QuoteEnd.363121fb.svg";
export { ForwardRef as ReactComponent };